module.exports = __webpack_public_path__ + "static/media/project4.a8fd9322.png";